<template>
  <div class="app-container">
    <el-button
      type="primary"
      @click="addMenu(0)"
      style="margin-bottom: 5px"
      v-if="roles.includes('/carport/tpl_add')"
      >添加</el-button
    >
    <el-button
      type="danger"
      @click="reset()"
      style="margin-bottom: 5px; float: right"
      >重置</el-button
    >
    <el-button
      type="primary"
      @click="(screen.page = 1), fetchData()"
      style="margin-bottom: 5px; float: right"
      >搜索</el-button
    >

    <el-input
      style="float: right; width: 200px; margin-left: 10px"
      v-model="screen.title"
      placeholder="请输入标题"
    ></el-input>
    <el-input
      style="float: right; width: 200px; margin-left: 10px"
      v-model="screen.price"
      type="number"
      placeholder="请输入价格"
    ></el-input>
    <el-select
      style="float: right"
      v-model="screen.type"
      placeholder="请选择类型"
    >
      <el-option label="全部类型" value=""></el-option>
      <el-option label="减免券" value="1"></el-option>
      <el-option label="折扣券" value="2"></el-option>
      <el-option label="全免券" value="3"></el-option>
      <el-option label="减时券" value="4"></el-option>
    </el-select>
    <!-- <el-select
      filterable
      multiple
      collapse-tags
      style="float: right"
      v-model="screen.park_id"
      placeholder="请选择园区"
      :disabled="userInfo.park_id != 0"
    >
      <el-option
        :label="item.name"
        :value="item.id"
        v-for="(item, index) in parkList"
        :key="index"
      ></el-option>
    </el-select> -->
    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" label="序号" width="50">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100" align="center">
      </el-table-column>
      <!-- <el-table-column label="园区">
        <template slot-scope="scope">
          <span>{{ scope.row.park_all }}</span>
        </template>
      </el-table-column> -->
      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.type == 1 ? "减免券" : scope.row.type == 2 ? "折扣券" :scope.row.type == 4 ? "减时券" : "全免券" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型值" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1"
            >{{ scope.row.value || "--" }}元</span
          >
          <span v-if="scope.row.type == 2"
            >{{ scope.row.value || "--" }}折</span
          >
          <span v-if="scope.row.type == 4"
            >{{ scope.row.value || "--" }}分</span
          >
          <span v-if="scope.row.type == 3">全免</span>
        </template>
      </el-table-column>
      <el-table-column label="价格" align="center">
        <template slot-scope="scope">
          {{ scope.row.price }}元
        </template>
      </el-table-column>
      <el-table-column label="有效期天数" align="center">
        <template slot-scope="scope">
          {{ scope.row.days }}天
        </template>
      </el-table-column>
      <!-- <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "禁用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/carport/tpl_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/carport/tpl_edit')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/carport/tpl_del')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="选择园区" prop="park_id">
          <el-select
            filterable
            multiple
            collapse-tags
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see' || userInfo.park_id != 0"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="模板标题" prop="title">
          <el-input
            class="w4"
            v-model="ruleForm.title"
            placeholder="请输入优惠券模板标题"
            :disabled="czType == 'see'"
          ></el-input>
        </el-form-item>
        <el-form-item label="模板类型" prop="type">
          <el-radio-group @input="typeChange" v-model="ruleForm.type" :disabled="czType == 'see'">
            <el-radio :label="1">减免券</el-radio>
            <el-radio :label="2">折扣券</el-radio>
            <el-radio :label="3">全免券</el-radio>
            <el-radio :label="4">减时券</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="类型值" prop="value" v-if="ruleForm.type != 3">
          <el-input
           :disabled="czType == 'see'"
            class="w4 numInput"
            v-model="ruleForm.value"
            placeholder="请输入值"
            type="number"
            min="1"
          >
            <template slot="append">
              {{ ruleForm.type == 1 ? "元" : ruleForm.type == 2 ? "折" : "分" }}
            </template>
          </el-input>
        </el-form-item>

        <el-form-item label="优惠券价格" prop="price">
          <el-input
            class="w4 numInput"
             :disabled="czType == 'see'"
            v-model="ruleForm.price"
            placeholder="请输入优惠券价格"
            type="number"
            min="1"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="有效期天数" prop="days">
          <el-input
           :disabled="czType == 'see'"
            class="w4 numInput"
            v-model="ruleForm.days"
            placeholder="请输入有效期天数"
            type="number"
            min="1"
          >
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { tpl_lists, tpl_add, tpl_info, tpl_edit, tpl_del } from "@/api/parking";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        page: 1,
        page_size: 15,
        park_id: [],
        title: "",
        type: "",
        price: "",
      },
      total: 0,
      ruleForm: {
        park_id: "",
        title: "",
        thumb: "",
        status: 1,
        content: "<h3>文本编辑</h3>",
        sort: "",
      },
      rules: {
        title: [
          { required: true, message: "请输入优惠券标题", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择优惠券列表" }],
        value: [{ required: true, message: "请输入值", trigger: "blur" }],
        price: [
          { required: true, message: "请输入优惠券价格", trigger: "blur" },
        ],
        days: [
          { required: true, message: "请输入有效期天数", trigger: "blur" },
        ],
      },
      multipleSelection: [],
      czType: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id.push(this.userInfo.park_id);
    // } else {
    //   this.screen.park_id = [];
    // }
    this.fetchData();
    // this.getPark();
  },
  methods: {
   // 优惠券类型切换
   typeChange(e){
    if(e == 3){
     this.ruleForm.value = '-1'
    }else{
     this.ruleForm.value = '1'
    }
   },
    delImg(path) {
      if (path) {
        delImage({ file: path }).then((ress) => {});
      }
    },
    reset() {
      this.screen = {
        park_id: [],
        title: "",
        page: 1,
        page_size: 15,
        type: "",
      };
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                id: that.ruleForm.id,
                title: that.ruleForm.title,
                park_id: this.$store.state.mainParkId,
                value: that.ruleForm.value,
                price: that.ruleForm.price,
                days: that.ruleForm.days,
                type: that.ruleForm.type,
              };
              tpl_edit(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑";
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id
      // this.oldImg = val.avatar_url
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      tpl_info({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        this.ruleForm = {
          id: res.data.info.id,
          title: res.data.info.title,
          value: res.data.info.value,
          park_id: this.$store.state.mainParkId,
          price: res.data.info.price,
          days: res.data.info.days,
          type: res.data.info.type,
        };
        this.$nextTick(()=>{
        this.drawer = true;
      })
      });
      
    },
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          tpl_del({ id: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              let data = {
                title: that.ruleForm.title,
                park_id: this.$store.state.mainParkId,
                value: that.ruleForm.value,
                price: that.ruleForm.price,
                days: that.ruleForm.days,
                type: that.ruleForm.type,
              };
              tpl_add(data).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加";
      this.czType = "add";
      this.ruleForm = {
        park_id: [],
        title: "",
        value: "",
        type: 1,
        price: "",
        days: 0,
      };
      // if (this.userInfo.park_id !== 0) {
      //   this.ruleForm.park_id.push(this.userInfo.park_id);
      // }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    tpl_del() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个用户");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          tpl_del({ id: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      const data = {
        park_id: this.screen.park_id.toString(),
        page: this.screen.page,
        page_size: this.screen.page_size,
        title: this.screen.title,
        type: this.screen.type,
        price:this.screen.price
      };
      tpl_lists(data).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}

::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
// select的tags过长显示...
.el-select__tags-text {
  display: inline-block;
  max-width: 140px;
  @media (max-width: 1400px) {
    max-width: 42px;
  }
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-select .el-tag__close.el-icon-close {
  top: -7px;
  right: -4px;
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
</style>
